<template>
    <div class="md:hidden">
        <div class="w-full fixed top-0 left-0 p-3 py-5 border-b border-b-gray-400 flex justify-between items-center bg-white">
            <div class="flex justify-start items-center">
                <slot name="left" />
            </div>
            <div class="flex-1 font-medium tracking-tight text-center">
                {{ title }}
            </div>
            <div class="flex justify-end items-center">
                <slot name="right" />
            </div>
        </div>
        <div class="h-[5.25rem]">

        </div>
    </div>
</template>

<script>
export default {
    props: [ 'title' ]
}
</script>
